var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-card-title',{staticClass:"text-center font-weight-black",staticStyle:{"font-size":"36px"},attrs:{"max-height":"600"}},[_vm._v("Добро пожаловать в панель статистики")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }